import React from 'react';
import { House, Eye, Pencil, CalendarDots, ListBullets, GridFour } from '@phosphor-icons/react';
import { getSymbol } from '../../utils/currency';

export const ListingRow = ({ listing, navigate, expanded = false }) => {
  const statusColors = {
    live: 'bg-emerald-100 text-emerald-700',
    paused: 'bg-amber-100 text-amber-700',
    pending: 'bg-blue-100 text-blue-700',
    draft: 'bg-slate-100 text-slate-600',
    rejected: 'bg-red-100 text-red-600',
  };

  return (
    <div className="flex items-center gap-3 p-3 bg-white rounded-xl border border-slate-100 hover:shadow-sm transition-shadow" data-testid={`listing-${listing.listing_id}`}>
      {listing.images && listing.images[0] ? (
        <img src={listing.images[0]} alt={listing.title} className="w-14 h-14 rounded-lg object-cover shrink-0" />
      ) : (
        <div className="w-14 h-14 bg-slate-100 rounded-lg flex items-center justify-center shrink-0">
          <House size={22} className="text-slate-400" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <p className="font-medium text-slate-900 truncate text-sm">{listing.title}</p>
        <div className="flex items-center gap-2 mt-1">
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${statusColors[listing.status] || statusColors.draft}`}>{listing.status}</span>
          <span className="text-xs text-slate-500">{getSymbol(listing.currency || listing.country)}{listing.base_price}/{listing.pricing_model}</span>
          {expanded && listing.category && (
            <span className="text-[10px] text-slate-400 uppercase">{listing.category.replace('_', ' ')}</span>
          )}
        </div>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <button onClick={() => navigate(`/listing/${listing.listing_id}`)} className="p-2 hover:bg-slate-100 rounded-lg" title="View"
          data-testid={`view-${listing.listing_id}`}>
          <Eye size={16} className="text-slate-500" />
        </button>
        <button onClick={() => navigate(`/seller/edit-listing/${listing.listing_id}`)} className="p-2 hover:bg-slate-100 rounded-lg" title="Edit"
          data-testid={`edit-${listing.listing_id}`}>
          <Pencil size={16} className="text-slate-500" />
        </button>
        <button onClick={() => navigate(`/seller/availability/${listing.listing_id}`)} className="p-2 hover:bg-blue-50 rounded-lg" title="Availability"
          data-testid={`availability-${listing.listing_id}`}>
          <CalendarDots size={16} className="text-blue-500" />
        </button>
        <button onClick={() => navigate(`/seller/services/${listing.listing_id}`)} className="p-2 hover:bg-purple-50 rounded-lg" title="Services"
          data-testid={`services-${listing.listing_id}`}>
          <ListBullets size={16} className="text-purple-500" />
        </button>
        <button onClick={() => navigate(`/seller/spaces/${listing.listing_id}`)} className="p-2 hover:bg-emerald-50 rounded-lg" title="Spaces"
          data-testid={`spaces-${listing.listing_id}`}>
          <GridFour size={16} className="text-emerald-500" />
        </button>
      </div>
    </div>
  );
};
